import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import TextInputWithEmoji from 'components/ReusableComponents/ManageHotel/TextInputWithEmoji'
import PropTypes from 'prop-types'

import styles from './EditStepDialog.module.scss'

const nightsToStayOptions = {
  1: '1 night',
  2: '2 nights',
  3: '3 nights'
}

function IncentiveStep({ incentive, setIncentive }) {
  function updateField(field, value) {
    setIncentive(current => ({
      ...current,
      [field]: value
    }))
  }

  function handlePercentChange(event) {
    const value = Number(event.target.value)

    if (value > 70) {
      updateField('maxDiscountPercentage', 70)
    } else if (value < 0 || Number.isNaN(value)) {
      updateField('maxDiscountPercentage', 0)
    } else {
      updateField('maxDiscountPercentage', value)
    }
  }

  const isPromoValid = !!incentive?.promotionCode?.match(/^[A-Za-z0-9]{1,15}$/)

  return (
    <div className={styles.incentiveStep}>
      <p className={styles.description}>
        Optional opt-in promotion shown on the guest landing page. Leave blank to hide the
        incentive block.
      </p>

      <TextInputWithEmoji
        label="Promo name"
        className={styles.textInput}
        value={incentive?.promotionTagline || ''}
        onValueChange={value => updateField('promotionTagline', value)}
        maxLength={20}
      />

      <div className={styles.incentiveRow}>
        <div className={styles.incentiveField}>
          <TextInput
            label="Offer promo code"
            className={styles.textInput}
            value={incentive?.promotionCode || ''}
            valid={!incentive?.promotionCode || isPromoValid}
            onChange={e => updateField('promotionCode', e.target.value)}
          />
          {incentive?.promotionCode && !isPromoValid && (
            <p className={styles.validationError}>Enter a valid promo code (1–15 characters)</p>
          )}
        </div>

        <div className={styles.incentiveField}>
          <Dropdown
            options={nightsToStayOptions}
            label="Minimum nights to stay"
            value={String(incentive?.minNightsToStay || 1)}
            onChange={e => updateField('minNightsToStay', Number(e.target.value))}
          />
        </div>
      </div>

      <TextInput
        label="Offer discount percentage"
        value={incentive?.maxDiscountPercentage ?? 0}
        type="number"
        className={styles.textInput}
        min={0}
        max={70}
        onChange={handlePercentChange}
        onBlur={e => (e.target.value === '' ? updateField('maxDiscountPercentage', 0) : undefined)}
      />
    </div>
  )
}

IncentiveStep.propTypes = {
  incentive: PropTypes.shape({
    promotionCode: PropTypes.string,
    promotionTagline: PropTypes.string,
    minNightsToStay: PropTypes.number,
    maxDiscountPercentage: PropTypes.number
  }).isRequired,
  setIncentive: PropTypes.func.isRequired
}

export default IncentiveStep
